import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Button.scss';

const Button = ({
  label, disabled, clickHandler, className, type, secondary,
}) => {
  const buttonClassNames = classNames({
    'main-button': true,
    'disabled-button': disabled,
    'secondary-button': secondary,
    [className]: true,
  });

  return (
    <button type={type} className={buttonClassNames} onClick={clickHandler}>
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  clickHandler: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  secondary: PropTypes.bool,
};
Button.defaultProps = {
  disabled: false,
  className: '',
  type: 'button',
  secondary: false,
  clickHandler: () => {},
};
export default Button;



// WEBPACK FOOTER //
// ./src/components/_atomic/Button/Button.js